import {
  AtendimentoOmnichannel,
  CannedMessageIcon,
  SairGray,
  spaikIcon
} from "../../assets";
import { css } from "@emotion/react";
import { AuthContextType, useAuth } from "../../auth/auth-provider";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setSidebarChats } from "../../redux/slices/sidebar";
import { useCallback, useEffect, useRef, useState } from "react";

import { Dropdown } from "primereact/dropdown";
import { ProgressSpinner } from "primereact/progressspinner";

import BotsServices from "../../services/bots";

import { AttachmentBlack, Send } from "../../assets";
import { AudioRecorder } from "../chat/AudioRecorder";
import { useToast } from "../../components";
import DialogPadrao from "../../components/DialogPadrao";
import { CannedMessage } from "../../components/CannedMessage";
import {
  CannedMessageAutocomplete,
  CannedMessageAutocompleteItem,
  CannedMessageRightModalContent,
  ContainerLeftModal,
  ContainerRightModal
} from "./styles";
import useCannedMessageShortcut from "./use-cannedMessage-shortcut";

import {
  setContactId,
  setNameContact,
  setShowModalContacts,
  setIsUploadingFile
} from "../../redux/slices/omnichannel";
import {
  AttachmentUploadProgress,
  buildComposerAttachments,
  ComposerAttachment,
  ComposerAttachmentsPreview,
  revokeComposerAttachments,
  validateComposerFiles
} from "./composer-attachments";
import {
  createThrottledProgressReporter,
  uploadFileChunked
} from "./chunked-upload";
import {
  OMNICHANNEL_COMPOSER_FILES_EVENT,
  OmnichannelComposerFilesEventDetail
} from "./composer-file-events";

const MIN_TEXTAREA_HEIGHT = 28;

type NoDialogProps = {
  botSelected: number | null;
  onBotSelectedChange: (v: number | null) => void;
  startDialogFromContact: (payload: any) => Promise<any>;
};

type AttachFilesProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const AttachFiles = ({ onChange, disabled = false }: AttachFilesProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <img
        src={AttachmentBlack}
        css={css`
          padding: 10px;
          cursor: ${disabled ? "not-allowed" : "pointer"};
          opacity: ${disabled ? 0.5 : 1};
        `}
        onClick={() => {
          if (disabled) return;
          inputFileRef.current?.click();
        }}
      />
      <input
        type="file"
        multiple={true}
        ref={inputFileRef}
        css={css`
          display: none;
        `}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};

export const NoDialog = ({
  botSelected,
  onBotSelectedChange,
  startDialogFromContact
}: NoDialogProps) => {
  const { logout, user, company } = useAuth() as AuthContextType;

  const dispatch = useAppDispatch();
  const toast = useToast();

  const [isMobile, setIsMobile] = useState(false);
  const sidebarChats = useAppSelector((state) => state.sidebar.sidebarChats);

  const contactId = useAppSelector((state) => state.omnichannel.contactId);
  const workspacesSelected = useAppSelector(
    (state) => state.workspaces.selectedWorkspaces
  );
  const { GetBotsWhatsAppQrCode } = BotsServices();
  const [bots, setBots] = useState<
    {
      id: number;
      name: string;
      workspaceId: number;
      qrCodeConnected: boolean;
    }[]
  >([]);

  const [loadDialog, setLoadDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [fileUploadProgress, setFileUploadProgress] =
    useState<AttachmentUploadProgress | null>(null);
  const isUploadingFile = fileUploadProgress !== null;

  useEffect(() => {
    dispatch(setIsUploadingFile(isUploadingFile));

    if (!isUploadingFile) return undefined;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [dispatch, isUploadingFile]);

  useEffect(
    () => () => {
      dispatch(setIsUploadingFile(false));
    },
    [dispatch]
  );

  const [message, setMessage] = useState<string>("");
  const messageRef = useRef<HTMLTextAreaElement>(null);
  const [concatenatedAudioBlob, setConcatenatedAudioBlob] = useState<
    Blob | MediaSource | undefined
  >(undefined);
  const [pendingAttachments, setPendingAttachments] = useState<
    ComposerAttachment[]
  >([]);
  const pendingAttachmentsRef = useRef<ComposerAttachment[]>([]);
  const {
    showCannedMessageModal,
    setShowCannedMessageModal,
    cannedMessages,
    shortcutSuggestions,
    shortcutSuggestionsHasMore,
    shortcutSuggestionsLoading,
    selectedShortcutSuggestionIndex,
    cannedMessagesSearch,
    setCannedMessagesSearch,
    cannedMessagesHasMore,
    cannedMessagesLoading,
    cannedMessageMode,
    setCannedMessageMode,
    hasShortcutTrigger,
    applyCannedMessageShortcut,
    handleShortcutSuggestionsKeyDown,
    loadMoreShortcutSuggestions,
    loadMoreCannedMessages,
    handleShortcutSuggestionMouseEnter,
    setShortcutSuggestionItemRef,
    handleCreateSuccess,
    handleUpdateSuccess,
    handleDeleteSuccess,
    shortcutSuggestionsListRef,
    setComposerMessage
  } = useCannedMessageShortcut({
    enabled: contactId !== 0,
    message,
    setMessage,
    messageRef
  });

  const handleShortcutSuggestionsScroll = (
    e: React.UIEvent<HTMLDivElement>
  ) => {
    if (!shortcutSuggestionsHasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - scrollTop <= clientHeight + 10) {
      loadMoreShortcutSuggestions();
    }
  };

  const linkStyle = css`
    color: #544f77;
    display: flex;
    align-items: center;
    gap: 15px;
    text-decoration: none;
    cursor: pointer;
  `;

  const handleSair = () => {
    logout();
    dispatch(setSidebarChats(false));
  };

  const GetChatbots = async () => {
    const companyId = user.admin ? company?.id : user.companyId;
    const availableWorkspaces =
      workspacesSelected?.length > 0
        ? workspacesSelected
        : user?.workspaces?.workspaces?.map((workspace) => workspace.id) ?? [];

    if (!companyId || !availableWorkspaces.length) return;

    try {
      const results = await GetBotsWhatsAppQrCode({
        companyId,
        workspaces: availableWorkspaces
      });
      setBots(results);
    } catch (error) {
      toast?.current?.show({
        life: 3000,
        severity: "error",
        summary: "Erro.",
        detail: "Erro ao buscar chatbots. Por favor tente mais tarde."
      });
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 500);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    GetChatbots();
  }, [
    user.admin,
    user.companyId,
    company?.id,
    workspacesSelected,
    user?.workspaces?.workspaces
  ]);

  useEffect(() => {
    if (contactId === 0 || showCannedMessageModal) return;

    window.setTimeout(() => {
      messageRef.current?.focus();
    }, 0);
  }, [contactId, showCannedMessageModal]);

  const resetTextareaHeight = useCallback(() => {
    if (messageRef.current) {
      messageRef.current.style.height = `${MIN_TEXTAREA_HEIGHT}px`;
    }
  }, []);

  const setComposerSubmitting = useCallback((value: boolean) => {
    isSubmittingRef.current = value;
    setIsSubmitting(value);
    setLoadDialog(value);
  }, []);

  const withComposerSubmission = useCallback(
    async (callback: () => Promise<void>) => {
      if (isSubmittingRef.current) return;

      setComposerSubmitting(true);

      try {
        await callback();
      } finally {
        setComposerSubmitting(false);
      }
    },
    [setComposerSubmitting]
  );

  useEffect(() => {
    pendingAttachmentsRef.current = pendingAttachments;
  }, [pendingAttachments]);

  useEffect(
    () => () => {
      revokeComposerAttachments(pendingAttachmentsRef.current);
    },
    []
  );

  const clearPendingAttachments = useCallback(() => {
    setPendingAttachments((prev) => {
      revokeComposerAttachments(prev);
      return [];
    });
  }, []);

  const removePendingAttachment = useCallback((id: string) => {
    if (isSubmittingRef.current) return;

    setPendingAttachments((prev) => {
      const attachmentToRemove = prev.find((attachment) => attachment.id === id);

      if (attachmentToRemove) {
        revokeComposerAttachments([attachmentToRemove]);
      }

      return prev.filter((attachment) => attachment.id !== id);
    });

    messageRef.current?.focus();
  }, []);

  const queuePendingAttachments = useCallback(
    (files: FileList | File[] | null) => {
      if (isSubmittingRef.current) return;

      if (!files) return;

      const selectedFiles = Array.isArray(files) ? files : Array.from(files);
      if (!selectedFiles.length) return;
      const validationResult = validateComposerFiles(selectedFiles);

      if (validationResult.errorMessage) {
        toast.current?.show({
          life: 5000,
          severity: "error",
          summary: "Erro.",
          detail: validationResult.errorMessage
        });
        return;
      }

      if (!validationResult.acceptedFiles.length) {
        if (validationResult.partialErrorMessage) {
          toast.current?.show({
            life: 5000,
            severity: "warn",
            summary: "Atenção.",
            detail: validationResult.partialErrorMessage
          });
        }
        return;
      }

      setConcatenatedAudioBlob(undefined);
      setPendingAttachments((prev) => [
        ...prev,
        ...buildComposerAttachments(validationResult.acceptedFiles)
      ]);

      if (validationResult.partialErrorMessage) {
        toast.current?.show({
          life: 5000,
          severity: "warn",
          summary: "Atenção.",
          detail: validationResult.partialErrorMessage
        });
      }

      messageRef.current?.focus();
    },
    [toast]
  );

  useEffect(() => {
    const handleComposerFiles = (event: Event) => {
      if (contactId === 0) {
        return;
      }

      const customEvent = event as CustomEvent<OmnichannelComposerFilesEventDetail>;
      queuePendingAttachments(customEvent.detail?.files ?? []);
    };

    window.addEventListener(
      OMNICHANNEL_COMPOSER_FILES_EVENT,
      handleComposerFiles as EventListener
    );

    return () => {
      window.removeEventListener(
        OMNICHANNEL_COMPOSER_FILES_EVENT,
        handleComposerFiles as EventListener
      );
    };
  }, [contactId, queuePendingAttachments]);


  const resetComposer = useCallback(() => {
    setMessage("");
    resetTextareaHeight();
    clearPendingAttachments();
    setConcatenatedAudioBlob(undefined);
  }, [clearPendingAttachments, resetTextareaHeight]);

  const sendMessageToContact = async () => {
    await withComposerSubmission(async () => {
      const text = message.trim();
      const files = pendingAttachments.map((attachment) => attachment.file);

      if (text.length === 0 && files.length === 0) return;

      if (!botSelected) {
        toast.current?.show({
          life: 3000,
          severity: "warn",
          summary: "Atenção.",
          detail: "Selecione um robô antes de enviar a mensagem."
        });
        return;
      }

      try {
        let lastStatus = 0;
        let lastResponse: any = null;

        for (let index = 0; index < files.length; index += 1) {
          const file = files[index];
          const reportProgress = createThrottledProgressReporter((fraction) => {
            setFileUploadProgress(
              fraction >= 1 ? null : { index, progress: fraction }
            );
          });

          let uploaded;
          try {
            // eslint-disable-next-line no-await-in-loop
            uploaded = await uploadFileChunked(file, reportProgress);
          } catch (error: any) {
            setFileUploadProgress(null);
            toast.current?.show({
              life: 5000,
              severity: "error",
              summary: "Erro.",
              detail:
                error?.message ?? `Não foi possível enviar o arquivo ${file.name}.`
            });
            return;
          }

          setFileUploadProgress(null);

          // eslint-disable-next-line no-await-in-loop
          const { status, response } = await startDialogFromContact({
            botId: botSelected,
            contactId,
            userId: user.id,
            file: {
              fileId: uploaded.id,
              name: file.name
            }
          });

          lastStatus = status;
          lastResponse = response;

          if (status !== 200 && status !== 201) {
            toast.current?.show({
              life: 3000,
              severity: "error",
              summary: "Erro.",
              detail: `Falha ao iniciar conversa com arquivo.`
            });
            return;
          }
        }

        if (text.length > 0) {
          const { status, response } = await startDialogFromContact({
            botId: botSelected,
            contactId,
            userId: user.id,
            message: text
          });

          lastStatus = status;
          lastResponse = response;

          if (status !== 200 && status !== 201) {
            return;
          }
        }

        if (lastStatus === 200 || lastStatus === 201) {
          const dialogId = lastResponse?.dialogId;

          if (dialogId) {
            dispatch(setShowModalContacts(false));
            dispatch(setContactId(0));
            dispatch(setNameContact(""));
            resetComposer();
            onBotSelectedChange(null);
          }
        }
      } catch (error: any) {
        toast.current?.show({
          life: 3000,
          severity: "error",
          summary: "Erro.",
          detail:
            error?.message || "Erro ao iniciar conversa a partir do contato."
        });
      }
    });
  };

  useEffect(() => {
    dispatch(setContactId(0));
    dispatch(setNameContact(""));
  }, [dispatch]);

  useEffect(() => {
    if (contactId === 0) {
      resetComposer();
    }
  }, [contactId, resetComposer]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        position: "relative"
      }}
    >
      <div
        css={css`
          background-color: #ffffff;
          align-items: center;
          display: flex;
          flex: 1;
          flex-direction: column;
          height: 100%;
          justify-content: center;
        `}
      >
        <div
          css={css`
            font-size: 22px;
            font-weight: bold;
          `}
        >
          Tudo calmo por aqui
        </div>

        <div
          css={css`
            color: #4c5862;
            font-size: 16px;
            margin-top: 10px;
            padding: 0 15px;
          `}
        >
          Você ainda não tem nenhum atendimento aberto.
        </div>

        <img
          src={AtendimentoOmnichannel}
          css={css`
            margin-top: 10px;
            @media (max-width: 600px) {
              max-width: 95%;
            }
          `}
        />
      </div>

      {contactId !== 0 && (
        <div
          css={css`
            width: 100%;
            padding: 0 20px 20px 20px;
            background: transparent;
          `}
        >
          {showCannedMessageModal && (
            <DialogPadrao
              displayDialog={showCannedMessageModal}
              contentStyle={{ height: "600px" }}
              onHide={() => setShowCannedMessageModal(false)}
              headerStyle={{
                backgroundColor: user.plataform.mainColor || "#2624CD"
              }}
            >
              <ContainerLeftModal>
                <CannedMessage
                  messages={cannedMessages}
                  search={cannedMessagesSearch}
                  onSearchChange={setCannedMessagesSearch}
                  hasMore={cannedMessagesHasMore}
                  loading={cannedMessagesLoading}
                  onLoadMore={loadMoreCannedMessages}
                  onModeChange={setCannedMessageMode}
                  onCreateSuccess={handleCreateSuccess}
                  onUpdateSuccess={handleUpdateSuccess}
                  onDeleteSuccess={handleDeleteSuccess}
                />
              </ContainerLeftModal>

              <ContainerRightModal
                style={{
                  backgroundColor: user.plataform.mainColor || "#2624CD"
                }}
              >
                <CannedMessageRightModalContent>
                  <div className="content">
                    <div className="iconWrapper">
                      {user.plataform.urlAvatar ? (
                        <img
                          src={user.plataform.urlAvatar}
                          style={{ height: "200px", marginTop: "-55px" }}
                        />
                      ) : (
                        <img
                          src={spaikIcon}
                          style={{ height: "200px", marginTop: "-55px" }}
                        />
                      )}
                    </div>

                    <div className="textGroup">
                      <div className="title">
                        {cannedMessageMode === "list"
                          ? "Escolha uma mensagem"
                          : "Escolha um atalho"}
                      </div>

                      <div className="description">
                        {cannedMessageMode === "list"
                          ? "Selecione uma mensagem da lista para editá-la, ou crie uma nova para que sua equipe possa usá-la digitando um atalho no atendimento."
                          : "Escreva a mensagem que será enviada quando o atalho for usado..."}
                      </div>
                    </div>
                  </div>
                </CannedMessageRightModalContent>
              </ContainerRightModal>
            </DialogPadrao>
          )}

          {loadDialog && (
            <div
              css={css`
                position: absolute;
                inset: 0;
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.7);
                pointer-events: all;
              `}
            >
              <div
                css={css`
                  transform: scale(2.2);
                `}
              >
                <ProgressSpinner />
              </div>
            </div>
          )}

          <div
            css={css`
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              gap: 10px;
            `}
          >
            <Dropdown
              className="no-dialog-bot-dropdown"
              css={css`
                height: 50px;
                min-height: 50px;
                border-radius: 24px;
                border: 2px solid #cbced1;
                align-items: center;

                .p-dropdown-label {
                  display: flex;
                  align-items: center;
                  height: 100%;
                  padding: 0 0 0 12px;
                }

                .p-placeholder {
                  display: flex;
                  align-items: center;
                  height: 100%;
                }

                .p-dropdown-trigger {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 38px;
                }
              `}
              style={{
                width: "200px",
                height: "50px"
              }}
              value={botSelected}
              options={bots}
              disabled={isSubmitting}
              onChange={(e) => onBotSelectedChange(e.value)}
              optionLabel="name"
              optionValue="id"
              placeholder="Selecione um robô"
              filter={true}
              emptyMessage="Sem robôs disponíveis"
            />

            <div
              css={css`
                display: flex;
                width: 100%;
                align-items: center;
                padding: 5px 10px 5px 20px;
                border-radius: 24px;
                border: 2px solid #cbced1;
                background-color: #ffffff;
                position: relative;
                z-index: 20;
                overflow: visible;
                transition: height 0.2s ease;
                height: auto;
                flex-direction: column;
              `}
            >
              <ComposerAttachmentsPreview
                attachments={pendingAttachments}
                mainColor={user.plataform.mainColor || "#2624CD"}
                onRemove={removePendingAttachment}
                disabled={isSubmitting}
                uploadProgress={fileUploadProgress}
              />

              <div
                css={css`
                  display: flex;
                  width: 100%;
                  align-items: center;
                  position: relative;
                `}
              >
                {hasShortcutTrigger ? (
                  <CannedMessageAutocomplete>
                    <div className="header">
                      <div className="headerLeft">
                        <img src={CannedMessageIcon} alt="Mensagens prontas" />
                        <span>Mensagens prontas</span>
                      </div>

                      <button
                        type="button"
                        className="manageButton"
                        onClick={() => setShowCannedMessageModal(true)}
                      >
                        Gerenciar
                      </button>
                    </div>

                    <div
                      className="suggestionsList"
                      ref={shortcutSuggestionsListRef}
                      onScroll={handleShortcutSuggestionsScroll}
                    >
                      {shortcutSuggestions.length ? (
                        shortcutSuggestions.map((item, index) => (
                          <CannedMessageAutocompleteItem
                            key={item.id}
                            ref={setShortcutSuggestionItemRef(index)}
                            type="button"
                            className={
                              selectedShortcutSuggestionIndex === index
                                ? "selected"
                                : undefined
                            }
                            onMouseEnter={() =>
                              handleShortcutSuggestionMouseEnter(index)
                            }
                            onClick={() => applyCannedMessageShortcut(item)}
                          >
                            <div className="topLine">
                              <div className="shortcut">/{item.shortcut}</div>
                              <div className="title">{item.title}</div>
                            </div>

                            <div className="message">{item.message}</div>
                          </CannedMessageAutocompleteItem>
                        ))
                      ) : (
                        <div className="emptyState">
                          {shortcutSuggestionsLoading
                            ? "Carregando mensagens prontas..."
                            : "Você não possui mensagens prontas."}
                        </div>
                      )}
                    </div>
                  </CannedMessageAutocomplete>
                ) : null}

                <button
                  type="button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "-10px",
                    marginRight: "6px",
                    padding: "0 8px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.5 : 1,
                    border: "none",
                    background: "transparent"
                  }}
                  onClick={() => {
                    if (isSubmitting) return;
                    setShowCannedMessageModal(true);
                  }}
                  disabled={isSubmitting}
                >
                  <img
                    src={CannedMessageIcon}
                    style={{ width: "20px" }}
                    alt="Canned Message"
                  />
                </button>

                {concatenatedAudioBlob === undefined && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      padding: "0",
                      marginRight: "10px"
                    }}
                  >
                    <textarea
                      placeholder={`Digite uma mensagem ou "/" para usar uma mensagem pronta...`}
                      css={css`
                        border: none;
                        display: block;
                        flex: 1;
                        font-family: "Poppins";
                        font-size: 14px;
                        line-height: 28px;
                        resize: none;
                        min-height: ${MIN_TEXTAREA_HEIGHT}px;
                        height: ${MIN_TEXTAREA_HEIGHT}px;
                        max-height: 150px;
                        padding: 0;
                        width: 100%;
                        overflow-y: auto;

                        @media screen and (max-width: 450px) {
                          margin-right: 0;
                        }

                        &::-webkit-scrollbar {
                          width: 8px;
                        }

                        &::-webkit-scrollbar-track {
                          background: transparent;
                        }

                        &::-webkit-scrollbar-thumb {
                          background-color: #c1c1c1;
                          border-radius: 4px;
                        }
                      `}
                      ref={messageRef}
                      value={message}
                      disabled={isSubmitting}
                      onChange={(e) => setComposerMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (isSubmitting) {
                          e.preventDefault();
                          return;
                        }

                        if (handleShortcutSuggestionsKeyDown(e)) {
                          e.preventDefault();
                          return;
                        }

                        if (
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          !e.ctrlKey &&
                          (message.trim().length > 0 ||
                            pendingAttachments.length > 0)
                        ) {
                          e.preventDefault();
                          sendMessageToContact();
                        }
                      }}
                    />
                  </div>
                )}

                <div
                  css={css`
                    display: flex;
                    margin-left: auto;
                    gap: 10px;
                    width: ${concatenatedAudioBlob === undefined
                      ? "unset"
                      : "100%"};
                  `}
                >
                  <AttachFiles
                    disabled={isSubmitting}
                    onChange={(e) => {
                      queuePendingAttachments(e.target.files);
                      e.target.value = "";
                    }}
                  />

                  {message.trim().length > 0 || pendingAttachments.length > 0 ? (
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "2.5rem",
                        padding: "0.5rem",
                        marginLeft: "-7px",
                        border: "none",
                        background: "transparent",
                        opacity: isSubmitting ? 0.5 : 1,
                        cursor: isSubmitting ? "not-allowed" : "pointer"
                      }}
                      onClick={() => void sendMessageToContact()}
                      disabled={isSubmitting}
                    >
                      <img
                        src={Send}
                        css={css`
                          background-color: #dddddf;
                          border-radius: 50%;
                          padding: 10px;
                          height: 43px;
                          width: 43px;
                        `}
                      />
                    </button>
                  ) : (
                    <AudioRecorder
                      disabled={isSubmitting}
                      concatenatedAudioBlob={concatenatedAudioBlob}
                      setConcatenatedAudioBlob={setConcatenatedAudioBlob}
                      onFilesAttached={(files) => {
                        queuePendingAttachments(files);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile && !sidebarChats && (
        <div
          css={css`
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            width: 100vw;
            padding: 0.7rem;
            background: #ffffff;
            margin-top: 0.5rem;
            z-index: 10;
          `}
        >
          <div onClick={handleSair} css={linkStyle}>
            <img src={SairGray} alt="Person Icon" width={30} height={30} />
          </div>
        </div>
      )}
    </div>
  );
};

export default NoDialog;
